export default __webpack_public_path__ + "static/media/bg-solicitar-cotacao.7f729d18.webp";